import { logoutRequest } from "../api/logoutRequest";
import { tokenStorage } from "shared/api/tokenStorage";
import { userStore } from "entities/user";

export const logoutUser = async () => {
  try {
    await logoutRequest();
  } catch (e) {
    console.error(e);
  } finally {
    tokenStorage.clearTokens();
    userStore.reset();
  }
};
